// eslint-disable-next-line no-shadow
export enum SalesmanType {
  ADMIN = 1,
  GENERAL = 2,
}